module.exports = __webpack_public_path__ + "static/img/spremidos-citrus.b146d03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/spremidos-citrus.png
// module id = ppC5
// module chunks = 0